import React, { useEffect } from 'react';
import { useLazyGetPageQuery } from '../../../redux/actions/Customer/FooterCustomer';
import { LegalPageLayout } from '../../../components/customer/LegalPageLayout';

export const AboutUsScreen: React.FC = () => {
    const [triggerGetPage, { data: response, isLoading, isError }] = useLazyGetPageQuery();

    useEffect(() => {
        triggerGetPage(1); // WebsitePageType.AboutUs = 1
    }, [triggerGetPage]);

    return (
        <LegalPageLayout
            title="About Us"
            subtitle="Learn more about our company, our values, and what we do."
            isLoading={isLoading}
            isError={isError}
            contentData={response?.value?.data || null}
        />
    );
};
export default AboutUsScreen;